const FONTFAMILY: { [key: string]: any } = {
  PRIMARY: 'Montserrat',
};

export default FONTFAMILY;
